/** Global styles - twin.macro BaseStyles removed during migration */
const GlobalStyles = () => null;

export default GlobalStyles;
